import { SizeProp } from '@fortawesome/fontawesome-svg-core'
import { faAppStore, faFacebook, faGooglePlay, faLinkedinIn, faXTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons'
import { faAllergies, faFile, faHome, faPlayCircle, faUserMd } from '@fortawesome/free-solid-svg-icons'
import { faCircle as faCircleLight } from '@fortawesome/pro-light-svg-icons'
import {
  faArrowCircleUp,
  faArrowDown,
  faArrowDownWideShort,
  faArrowUp,
  faArrowUpWideShort,
  faBanSmoking,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleCheck,
  faCirclePlus,
  faCloudArrowDown,
  faEarthAmericas,
  faEdit,
  faExclamationCircle,
  faFilePdf,
  faGaugeSimple,
  faGaugeSimpleMin,
  faHeadSideCough,
  faHeartCircleCheck,
  faHeartHalfStroke,
  faHistory,
  faInfoCircle,
  faLeftToLine,
  faLink,
  faLinkHorizontal,
  faLungsVirus,
  faMagnifyingGlassPlus,
  faNewspaper,
  faRedo,
  faTimes,
  faTrashXmark,
  faVial,
  faViruses,
  faHeart as heartOutline,
} from '@fortawesome/pro-regular-svg-icons'
import {
  faAlarmClock,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faArrowLeft,
  faArrowRight,
  faArrowSquareDown,
  faArrowUp as faArrowUpSolid,
  faBadgeCheck,
  faBan,
  faBars,
  faBolt,
  faBookSpells,
  faBoxArchive,
  faBrain,
  faCalendar,
  faCapsules,
  faCheckCircle,
  faCircleExclamation,
  faCircleInfo,
  faCirclePlay,
  faCircleQuestion,
  faCircleXmark,
  faCloudUploadAlt,
  faCommentsAlt,
  faDollarSign,
  faDumbbell,
  faEnvelope,
  faExternalLinkAlt,
  faEyeDropper,
  faFileAlt,
  faFileCircleCheck,
  faFileMedical,
  faFilePrescription,
  faFilter,
  faFilterList,
  faHandHeart,
  faHeadSideBrain,
  faHeart,
  faHeartbeat,
  faInhaler,
  faLock,
  faLungs,
  faMapMarkerAlt,
  faMinus,
  faMinusCircle,
  faMobileAndroidAlt,
  faPaperPlane,
  faPaperclip,
  faPhoneRotary,
  faPhoneVolume,
  faPlateUtensils,
  faPlay,
  faPlus,
  faPrescriptionBottleAlt,
  faPrescriptionBottlePill,
  faReply,
  faSalad,
  faSearch,
  faSkeleton,
  faSparkles,
  faSquare,
  faStethoscope,
  faSyringe,
  faTablets,
  faTint,
  faTrashAlt,
  faTriangle,
  faTrophyStar,
  faUser,
  faUserHeadset,
  faUserLock,
  faWater,
  faWeight,
  faCircle as solidCircle,
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { IconNames } from 'types/IconNames'

interface Props {
  name: IconNames
  size?: SizeProp
  link?: string
  color?: string
  styles?: React.CSSProperties
  className?: string
}
export const iconNames = {
  allergy: faAllergies,
  'alarm-clock': faAlarmClock,
  'angle-left': faAngleDoubleLeft,
  'angle-right': faAngleDoubleRight,
  'arrow-square-down': faArrowSquareDown,
  'arrow-up-circle': faArrowCircleUp,
  'arrow-up': faArrowUp,
  'arrow-down': faArrowDown,
  'arrow-up-solid': faArrowUpSolid,
  'arrow-right': faArrowRight,
  'arrow-left': faArrowLeft,
  archive: faBoxArchive,
  attachment: faPaperclip,
  badge: faBadgeCheck,
  back: faLeftToLine,
  ban: faBan,
  'ban-smoking': faBanSmoking,
  bars: faBars,
  bottle: faPrescriptionBottleAlt,
  brain: faBrain,
  calendar: faCalendar,
  capsules: faCapsules,
  check: faCheck,
  circleCheck: faCircleCheck,
  'check-circle': faCheckCircle,
  'chevron-left': faChevronLeft,
  'chevron-right': faChevronRight,
  'chevron-down': faChevronDown,
  'chevron-up': faChevronUp,
  circle: faCircle,
  circleX: faCircleXmark,
  'circle-plus': faCirclePlus,
  'circle-light': faCircleLight,
  'cloud-arrow-down': faCloudArrowDown,
  'cloud-upload': faCloudUploadAlt,
  comment: faCommentsAlt,
  cough: faHeadSideCough,
  circleExclamation: faCircleExclamation,
  doctor: faUserMd,
  dollar: faDollarSign,
  dumbbell: faDumbbell,
  earth: faEarthAmericas,
  edit: faEdit,
  envelope: faEnvelope,
  exclamation: faExclamationCircle,
  'external-link': faExternalLinkAlt,
  'eye-dropper': faEyeDropper,
  facebook: faFacebook,
  file: faFile,
  fileLines: faFileAlt,
  recommendations: faFileMedical,
  'file-pdf': faFilePdf,
  'file-rx': faFilePrescription,
  fileCircleCheck: faFileCircleCheck,
  filter: faFilter,
  'filter-list': faFilterList,
  'gauge-easy': faGaugeSimpleMin,
  'gauge-average': faGaugeSimple,
  'hand-heart': faHandHeart,
  heart: faHeart,
  heartOutline: heartOutline,
  'heart-circle-check': faHeartCircleCheck,
  'heart-half': faHeartHalfStroke,
  heartbeat: faHeartbeat,
  history: faHistory,
  home: faHome,
  inhaler: faInhaler,
  ios: faAppStore,
  'info-circle': faInfoCircle,
  'info-circle-solid': faCircleInfo,
  lightning: faBolt,
  linkedin: faLinkedinIn,
  link: faLink,
  linkHorizontal: faLinkHorizontal,
  lock: faLock,
  lung: faLungs,
  'lung-virus': faLungsVirus,
  'magnifying-glass-plus': faMagnifyingGlassPlus,
  'map-marker-alt': faMapMarkerAlt,
  minus: faMinus,
  'minus-circle': faMinusCircle,
  'mobile-phone': faMobileAndroidAlt,
  newspaper: faNewspaper,
  play: faGooglePlay,
  'play-start': faPlay,
  phone: faPhoneRotary,
  phoneVolume: faPhoneVolume,
  pillBottle: faPrescriptionBottlePill,
  plate: faPlateUtensils,
  plus: faPlus,
  question: faCircleQuestion,
  redo: faRedo,
  reply: faReply,
  salad: faSalad,
  search: faSearch,
  'side-brain': faHeadSideBrain,
  skeleton: faSkeleton,
  sparkles: faSparkles,
  'spell-book': faBookSpells,
  'sort-up': faArrowUpWideShort,
  'sort-down': faArrowDownWideShort,
  send: faPaperPlane,
  solidCircle: solidCircle,
  square: faSquare,
  start: faPlayCircle,
  stethoscope: faStethoscope,
  syringe: faSyringe,
  tablets: faTablets,
  times: faTimes,
  trash: faTrashAlt,
  trashX: faTrashXmark,
  triangle: faTriangle,
  trophy: faTrophyStar,
  user: faUser,
  'user-headset': faUserHeadset,
  vial: faVial,
  video: faCirclePlay,
  viruses: faViruses,
  water: faWater,
  'water-drop': faTint,
  weight: faWeight,
  'user-lock': faUserLock,
  youtube: faYoutube,
  x: faXTwitter,
}

function Icon({ name, link, color, size = 'lg', styles, className }: Props) {
  return link ? (
    <a href={link} style={{ color: 'black' }} target="_blank" rel="noreferrer">
      <FontAwesomeIcon style={{ ...styles }} className={className} size={size} color={color} icon={name ? iconNames[name] : iconNames['file']} />
    </a>
  ) : (
    <FontAwesomeIcon style={{ ...styles }} className={className} size={size} color={color} icon={name ? iconNames[name] : iconNames['file']} />
  )
}

export default React.memo(Icon)
